import RingsModal from '../../components/ringsModal';
function showRings(data) {
  data = {
    imgList: [
      {
        url:
          'https://test.res.jsvry.cn/test/system/2020/09/11/150107qdmfbh8.jpg?x-oss-process=image/resize,m_fill,h_600,w_1000',
        text: `九商VR云是一款轻设计在线全景制作网站，
        可以让摄影师（创业者、全景爱好者）掌握VR全景从制作到编辑、从存储到分享、模板共享与交易的全过程。`,
      },
      {
        url:
          'https://test.res.jsvry.cn/test/system/2020/05/25/15441919ozhd4.jpg?x-oss-process=image/resize,m_fill,h_600,w_1000',
        text: `九商VR云是一款轻设计在线全景制作网站，
        行业覆盖如房地产、景区、电影院、医院、学校、KTV、酒吧、健身房、工厂、汽车、驾校、餐饮、商场、农家乐、政府单位、商业街、游乐园等等各个行业。
        提供了丰富的全景图，全景模板，全景周边产品及全景摄影师等，
        同时具有视角、热点、沙盘、遮罩、音乐、界面等丰富的全景编辑工具。
        可以让摄影师（创业者、全景爱好者）掌握VR全景从制作到编辑、从存储到分享、模板共享与交易的全过程。
        同时具有视角、热点、沙盘、遮罩、音乐、界面等丰富的全景编辑工具。
        可以让摄影师（创业者、全景爱好者）掌握VR全景从制作到编辑、从存储到分享、模板共享与交易的全过程。`,
      },
      {
        url:
          'https://test.res.jsvry.cn/test/system/2020/09/11/150107qdmfbh8.jpg?x-oss-process=image/resize,m_fill,h_600,w_1000',
        text: '',
      },
      {
        url:
          'https://test.res.jsvry.cn/test/system/2020/05/25/15441919ozhd4.jpg?x-oss-process=image/resize,m_fill,h_600,w_1000',
        text: `九商VR云是一款轻设计在线全景制作网站，
        行业覆盖如房地产、景区、电影院、医院、学校、KTV、酒吧、健身房、工厂、汽车、驾校、餐饮、商场、农家乐、政府单位、商业街、游乐园等等各个行业。
        同时具有视角、热点、沙盘、遮罩、音乐、界面等丰富的全景编辑工具。
        可以让摄影师（创业者、全景爱好者）掌握VR全景从制作到编辑、从存储到分享、模板共享与交易的全过程。`,
      },
    ],
    id: 100,
  };
  new RingsModal({
    imgList: data.imgList,
    wrapper: this.$container.get(0),
  });
}
export default {
  showRings,
};
